<template>
  <div class="px-3 pt-3">
    <!-- Cardul listei nu are padding (has-table); spatiul aliniaza filtrele cu textul din tabel. -->
    <div class="columns is-multiline is-vcentered">
      <div class="column is-5">
        <b-field label="Cauta">
          <b-input
            :value="search"
            icon="magnify"
            placeholder="Nume, CNP sau numar (00012/2026)"
            @input="onSearchInput"
          />
        </b-field>
      </div>
      <div class="column is-3">
        <b-field>
          <template #label>
            Stare
            <resdps-help-tip :text="statusFilterHelp" />
          </template>
          <b-select
            :value="value.status"
            expanded
            @input="change({ status: $event })"
          >
            <option
              v-for="option in statusOptions"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-2">
        <b-field label="An inregistrare">
          <b-select
            :value="value.year"
            expanded
            @input="change({ year: $event })"
          >
            <option :value="null">Toti</option>
            <option v-for="year in years" :key="year" :value="year">
              {{ year }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-2 has-text-right total-column">
        <span class="tag is-light is-medium mb-1">{{ total }} dosare</span>
      </div>
    </div>
  </div>
</template>

<script>
import { LIST_STATUS_OPTIONS, registerYears } from "@/helpers/resdps";
import { SCREEN_HELP } from "@/helpers/resdpsHelp";
import ResdpsHelpTip from "@/components/succession/resdps-help-tip.vue";

const SEARCH_DELAY_MS = 400;

export default {
  name: "SuccessionFilesFilter",
  components: { ResdpsHelpTip },
  props: {
    // { status, year, search }, din adresa paginii
    value: {
      type: Object,
      required: true,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      search: this.value.search,
      statusOptions: LIST_STATUS_OPTIONS,
      statusFilterHelp: SCREEN_HELP.statusFilter,
      years: registerYears(new Date()),
      timer: null,
    };
  },
  watch: {
    "value.search"(search) {
      if (search !== this.search.trim()) this.search = search;
    },
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    onSearchInput(search) {
      this.search = search;
      clearTimeout(this.timer);
      this.timer = setTimeout(this.applySearch, SEARCH_DELAY_MS);
    },
    applySearch() {
      clearTimeout(this.timer);
      this.change({ search: this.search.trim() });
    },
    change(changes) {
      this.$emit("change", { ...this.value, ...changes });
    },
  },
};
</script>

<style scoped>
/* Numarul de dosare sta pe linia campurilor, nu la mijlocul etichetei si al campului. */
.total-column {
  align-self: flex-end;
}
</style>
